import "@layouts/style.css";

import "@layouts/tailwind.css";

import "@layouts/satoshi.css";

import "@layouts/cardGradients.css";

import AlertToast from "@components/AlertToast";
import ManualFeedback from "@components/Feedback/ManualFeedback";
import { AlertProvider } from "@context/AlertContext";
import { AuthProvider } from "@context/AuthContext";
import { GuidedSearchProvider } from "@context/GuidedSearchContext";
import { ModalProvider } from "@context/ModalContext";
import { ResultProvider } from "@context/ResultContext";
import { SearchProvider } from "@context/SearchContext";
import { SearchCountProvider } from "@context/SearchCountContext";
import { initPosthogClient, posthog } from "@service/posthogClient";
import { initSessionTracker } from "@service/sessionTracker";
import type React from "react";
import { useEffect } from "react";
import { usePageContext } from "vike-react/usePageContext";

export default function LayoutDefault({
	children,
}: { children: React.ReactNode }) {
	useEffect(() => {
		initPosthogClient();
		posthog.capture("app_loaded");

		// Initialize session tracking
		initSessionTracker();
	}, []);
	return (
		<div className="h-full w-full m-0 flex flex-col relative items-center">
			<AlertProvider>
				<AuthProvider>
					<GuidedSearchProvider>
						<ModalProvider>
							<ResultProvider>
								<SearchProvider>
									<SearchCountProvider>{children}</SearchCountProvider>
								</SearchProvider>
							</ResultProvider>
						</ModalProvider>
					</GuidedSearchProvider>
				</AuthProvider>
				<AlertToast classname="slide"></AlertToast>
			</AlertProvider>
		</div>
	);
}
